// YouTube configuration
// This file holds fallback data for when the YouTube API is not available or configured

export const youtubeConfig = {
  channelId: 'UCfBbmHT-gDLvEO4rMfR4bhQ', // @beniaminkwak channel ID
  channelUrl: 'https://www.youtube.com/@beniaminkwak',
  // Temporary fallback videos until the API is configured
  fallbackVideos: [
    {
      id: 'VOZuigmHV5w',
      title: 'Bicep vs ARM - Which Azure IaC Tool Should You Use in 2025',
      thumbnail: 'https://i.ytimg.com/vi/VOZuigmHV5w/maxresdefault.jpg',
      url: 'https://www.youtube.com/watch?v=VOZuigmHV5w',
      publishedAt: 'Apr 18, 2025'
    }
    // Add more videos here if needed
  ]
};